import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import ComponentHeader from "../../UI/ComponentHeader";

type PortalAdditionalInformationCardProps = {
    project: any;
};

const PortalAdditionalInformationCard: React.FC<PortalAdditionalInformationCardProps> = ({ project }) => {
    // Card displays additional info about a project in the portal
    if (project.detail === null || project.detail === "") {
        return null;
    }
    return (
        <div className="flex flex-col gap-2">
            <ComponentHeader label="Additional Information" icon={faInfoCircle} color="text-plot-yellow" />
            <div className="p-4 rounded-lg shadow-sm border bg-gray-50 dark:bg-neutral-800 border-gray-200 dark:border-neutral-700">
                <div
                    id="projectInfoDetails"
                    className="ql-editor"
                    dangerouslySetInnerHTML={{
                        __html: project.detail,
                    }}
                />
            </div>
        </div>
    );
};

export default PortalAdditionalInformationCard;
